module.exports = __webpack_public_path__ + "6ffd1f416a6278774375ebd6cf12a412.MP3";